import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-0 top-3 z-50 flex justify-center px-3 sm:inset-x-auto sm:bottom-24 sm:left-5 sm:top-auto sm:justify-start sm:px-0" data-id="element-47" data-mp="1164o26qe2u2c">
      <AnimatePresence data-id="element-48" data-mp="1aw63ka4of45n">
        {visible && !dismissed && <motion.div role="status" initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_18px_40px_-12px_rgba(11,27,46,0.35)]" data-id="element-49" data-mp="1az1yrqp53eqe">
            <img src={images.main} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-50" data-mp="28mkifwkca196" />
            <div className="min-w-0 text-left" data-id="element-51" data-mp="23npnjw93km8p">
              <p className="text-sm font-bold leading-snug text-ink" data-id="element-52" data-mp="2anjjthbtab8c">
                {buyer.name} <span className="font-medium text-ink-muted" data-id="element-53" data-mp="2fn4qkdx83nvm">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink-muted" data-id="element-54" data-mp="2kmhgx8nazd2y">just purchased the Rhinoplasty Master Planner™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-55" data-mp="2pkizztkqbcef">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="1rz4vx2wsjdbr" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-ink-muted transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-57" data-mp="21wj8grflfhys">
              <XIcon className="h-4 w-4" data-id="element-58" data-mp="195rem0m035em" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}